import React from 'react';
import { Link } from 'react-router-dom';
import { Wrench } from 'lucide-react';
import { trackEvent } from '../utils/analytics';

export const TechnicianNetworkCta = ({ location = 'repair_page' }) => (
  <section className="py-12 bg-white border-y border-gray-200" data-testid={`technician-network-cta-${location}`}>
    <div className="mx-auto max-w-7xl px-4 sm:px-6">
      <div className="grid lg:grid-cols-[1fr_auto] gap-6 items-center bg-gray-50 border border-gray-200 p-6 sm:p-8 rounded-sm">
        <div className="flex gap-4 items-start">
          <div className="hidden sm:flex h-11 w-11 items-center justify-center bg-gray-900 text-white rounded-sm" data-testid={`technician-network-cta-icon-${location}`}>
            <Wrench className="h-5 w-5" />
          </div>
          <div>
            <h2 className="text-xl sm:text-2xl font-extrabold tracking-tight text-gray-900 mb-2" data-testid={`technician-network-cta-heading-${location}`}>Are you an experienced 3D printer technician?</h2>
            <p className="text-sm sm:text-base text-gray-600 leading-relaxed max-w-3xl" data-testid={`technician-network-cta-summary-${location}`}>Apply to join the 3D Printer Gear contractor network for repair, maintenance, school and business service jobs across Australia.</p>
          </div>
        </div>
        <Link
          to="/apply-as-technician"
          onClick={() => trackEvent('technician_application_cta_click', { cta_location: location })}
          className="inline-flex justify-center bg-gray-900 hover:bg-black text-white text-sm font-extrabold px-5 py-3 rounded-sm border-b-4 border-orange-500 hover:border-orange-400 transition-colors"
          data-testid={`technician-network-cta-link-${location}`}
        >
          Apply as a Technician
        </Link>
      </div>
    </div>
  </section>
);